import React from 'react';
import styles from '../Rooms.module.css';

const FixedIcon = ({ index, icon, animateFrom, isMobile, zoomOutHandler }) => {
  const id = isMobile ? 'mobileIcon' : 'icon';
  return (
    <div
      id={`iconFixed${index}`}
      className={`${styles.iconFixed} visibleFlag ${animateFrom} fixed-icon`}
    >
      <div
        onMouseDown={(e) => {
          if (e.button === 0) {
            zoomOutHandler();
            if (typeof document !== 'undefined') {
              const iconTo = document.getElementById(`${id}${index}`);
              iconTo.scrollIntoView({
                behavior: 'smooth',
                block: 'end',
                inline: 'center',
              });
            }
          }
        }}
      >
        <img src={icon} alt="" className={styles.iconSvgFixed} />
      </div>
    </div>
  );
};

export default FixedIcon;
